import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onAddTeams", "onRemoveTeam", "onAddUsers", "onRemoveUser", "onSetEveryone", "label", "teams", "users", "description", "isLockedToTeam", "emptyAudienceType", "required", "usersType"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import Button from 'components/Button';
import Pill from 'components/Pill';
import InlineList from 'components/InlineList';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import Text from 'components/Text';
import TeamsAndUsersList from './common/TeamsAndUsersList';
function SelectedAudience(_ref) {
  var emptyAudienceType = _ref.emptyAudienceType,
    description = _ref.description,
    teams = _ref.teams,
    users = _ref.users,
    onRemoveTeam = _ref.onRemoveTeam,
    onRemoveUser = _ref.onRemoveUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (emptyAudienceType === 'everyone') {
    return /*#__PURE__*/React.createElement(Pill, {
      as: "p"
    }, t('state_everyone'));
  }
  if (emptyAudienceType === 'none') {
    return /*#__PURE__*/React.createElement(Pill, null, t('amount_none'));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement(Flag, {
    token: /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: "info",
      dimmed: true
    }),
    spacing: "xs",
    my: "xs"
  }, /*#__PURE__*/React.createElement(Text, null, description)), /*#__PURE__*/React.createElement(TeamsAndUsersList, {
    teams: teams,
    users: users,
    onRemoveTeam: onRemoveTeam,
    onRemoveUser: onRemoveUser
  }));
}
function AudienceIncludingUsersField(_ref2) {
  var onAddTeams = _ref2.onAddTeams,
    onRemoveTeam = _ref2.onRemoveTeam,
    onAddUsers = _ref2.onAddUsers,
    onRemoveUser = _ref2.onRemoveUser,
    onSetEveryone = _ref2.onSetEveryone,
    label = _ref2.label,
    teams = _ref2.teams,
    users = _ref2.users,
    description = _ref2.description,
    isLockedToTeam = _ref2.isLockedToTeam,
    emptyAudienceType = _ref2.emptyAudienceType,
    required = _ref2.required,
    _ref2$usersType = _ref2.usersType,
    usersType = _ref2$usersType === void 0 ? 'members' : _ref2$usersType,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var teamsButtonLabel = teams.length === 0 ? t('actions_select_teams') : t('actions_edit_teams');
  var memberUsersButtonLabel = users.length === 0 ? t('actions_select_users') : t('actions_edit_users');
  var individualUsersButtonLabel = users.length === 0 ? t('actions_select_individuals') : t('actions_edit_individuals');
  var usersButtonLabel = usersType === 'members' ? memberUsersButtonLabel : individualUsersButtonLabel;
  var teamsButtonIcon = teams.length === 0 ? 'plus' : 'edit';
  var usersButtonIcon = users.length === 0 ? 'plus' : 'edit';
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "fieldset",
    label: label || t('property_audience'),
    required: required
  }, otherProps), /*#__PURE__*/React.createElement(SelectedAudience, {
    teams: teams,
    users: users,
    emptyAudienceType: emptyAudienceType,
    description: description,
    onRemoveTeam: onRemoveTeam,
    onRemoveUser: onRemoveUser
  }), /*#__PURE__*/React.createElement(Box, {
    mt: "xs"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs",
    top: "xs"
  }, !isLockedToTeam && /*#__PURE__*/React.createElement(Button, {
    icon: teamsButtonIcon,
    onClick: onAddTeams,
    size: "medium"
  }, teamsButtonLabel), /*#__PURE__*/React.createElement(Button, {
    icon: usersButtonIcon,
    onClick: onAddUsers,
    size: "medium"
  }, usersButtonLabel), (teams.length !== 0 || users.length !== 0 || emptyAudienceType === 'none') && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: onSetEveryone
  }, t('actions_set_audience_to_everyone')))));
}
export default AudienceIncludingUsersField;